import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'displayTypes' })
export class DisplayTypesPipe implements PipeTransform {

  transform(value: any): any {
    if (!value) {
      return '';
    }

    return value
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }

}
